export const APP_VERSION = "0.7.0";
